/**
 * Segment name validation shared across the create / edit / clone flows.
 *
 * Rules:
 *  - required (non-empty after trim)
 *  - at most SEGMENT_NAME_MAX_LENGTH characters
 *  - only Latin letters (accents allowed), digits, spaces and hyphens.
 *    Special characters and non-Latin scripts (e.g. Chinese/CJK, Cyrillic,
 *    Arabic, emoji) are rejected.
 */

export const SEGMENT_NAME_MAX_LENGTH = 100;

// Latin letters (incl. accented), digits, spaces and hyphens only.
const SEGMENT_NAME_ALLOWED_PATTERN = /^[\p{Script=Latin}0-9\s-]+$/u;

export function validateSegmentName(rawName) {
    const name = (rawName || "").trim();

    if (!name) {
        return { valid: false, error: "Le nom du segment est requis." };
    }

    if (name.length > SEGMENT_NAME_MAX_LENGTH) {
        return {
            valid: false,
            error: `Le nom du segment ne doit pas dépasser ${SEGMENT_NAME_MAX_LENGTH} caractères.`,
        };
    }

    if (!SEGMENT_NAME_ALLOWED_PATTERN.test(name)) {
        return {
            valid: false,
            error:
                "Le nom du segment ne doit contenir que des lettres, des chiffres, des espaces et des tirets. " +
                "Les caractères spéciaux et non latins (par ex. chinois) ne sont pas autorisés.",
        };
    }

    return { valid: true };
}
